import { render } from "./Spacing.vue?vue&type=template&id=70914108"
import script from "./Spacing.vue?vue&type=script&lang=ts"
export * from "./Spacing.vue?vue&type=script&lang=ts"
script.render = render

export default script